import React from "react";

import "./detailInstructor.css";

const DetailInstructor = (props) => {
  if (!props?.data) {
    return <h3>ma'lumotlar mavjud emas!</h3>;
  }
  const { photo, name, rank, social, email, phone, description } = props?.data;
  // console.log(props.data);
  
  return (
    <div
      className="tab-pane fade"
      id="course-instructor"
      role="tabpanel"
      aria-labelledby="course-instructor-tab"
    >
      <div className="course-instructor">
        <div className="instructor">
          <div className="instructor-header d-flex align-items-center">
            <div className="instructor-img w-25 me-4">
              <img src={process.env.REACT_APP_UPLOADS_URL + photo} alt={name} />
            </div>
            <div className="instructor-info">
              <span className="fs-4">{name}</span>
              {/* <span className="theme-clr ms-2">({creator_skill})</span> */}
              <ul>
                <li>
                  <i className="theme-clr me-1 fas fa-graduation-cap"></i>
                  {rank}
                </li>
                <li>
                  <i className="theme-clr me-1 fas fa-envelope"></i>
                  {email}
                </li>
                <li>
                  <i className="theme-clr me-1 fas fa-phone"></i>
                  {phone}
                </li>
              </ul>
            </div>
          </div>
          <div className="instructor-desc">
            <p className="mt-3 fs-5">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailInstructor;
